export default () => {

  const $scroll          = $('.js-scroll a');
  const _speed = 400;

  $scroll.on('click',function() {
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    $('body,html').animate({scrollTop:position-120}, _speed, 'easeInOutCubic');
    return false;
  });

};



// WEBPACK FOOTER //
// ./src/assets/js/utilities/smoothscroll.js